import { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { JobTypeLResponse } from '@doda/api-client/aspida/@types';
import { appAxios } from '../../libs/axios/appAxios';

export const getJobType = async (headers: IncomingHttpHeaders) => {
  return appAxios({
    url: '/api/v1/jobType',
    headers,
  }).then((res: AxiosResponse<JobTypeLResponse[]>) => {
    return res.data;
  });
};

export const getJobTypeMasterSort = async (headers: IncomingHttpHeaders) => {
  return appAxios({
    url: '/api/v1/jobType',
    params: { sortKey: 'master' },
    headers,
  }).then((res: AxiosResponse<JobTypeLResponse[]>) => {
    return res.data;
  });
};
